function buttonfeature() {
  const e = $('.featureLineupContainer');
  if (e.length > 0) {
    e.each((index, element) => {
      const moreButton = $(element).find('.featureLineup-more');
      const buyNowButton = $(element).find('.featureLineup-buynow');
      const textContainer = $(element).find('.featureLineup-text');
      const titleElem = $(element).find('.featureLineup-title');
      const descriptionText = $(element).find('.featureLineup-text').text().trim();

      const titleText = titleElem.text().trim(); // Get the title text and trim any extra whitespace
      const maxLengthTitle = 33; // Maximum characters for title
      const maxLengthDescription = 120; // Maximum characters for description

      // Limit title length
      let trimmedTitle =
        titleText.length > maxLengthTitle
          ? titleText.substring(0, maxLengthTitle) + '...'
          : titleText;

      // Limit description length
      let trimmedDescription =
        descriptionText.length > maxLengthDescription
          ? descriptionText.substring(0, maxLengthDescription) + '...'
          : descriptionText;

      // Create a wrapper div for buttons
      const buttonWrap = $('<div class="button-wrap"></div>');

      // Append both buttons to the wrapper div
      buttonWrap.append(moreButton);
      buttonWrap.append(buyNowButton);

      if (textContainer.length > 0) {
        // If .featureLineup-text exists
        textContainer.html(`<span class="featureLineup-text-content">${trimmedDescription}</span>`); // Use trimmed description
        buttonWrap.appendTo(textContainer); // Append buttonWrap to .featureLineup-text
        titleElem.text(trimmedTitle); // Set trimmed title
        titleElem.clone().appendTo(textContainer); // Append cloned title
      } else {
        // If .featureLineup-text does not exist
        titleElem.text(trimmedTitle); // Set trimmed title
        buttonWrap.prepend(titleElem.clone()); // Prepend cloned title to buttonWrap
        buttonWrap.append(`<span class="featureLineup-text-content">${trimmedDescription}</span>`); // Append trimmed description
        $(element).append(buttonWrap); // Append buttonWrap to the container
      }
    });
  }
}

// Check Window Size
$(document).ready(function () {
  buttonfeature();
  $('.generalmessage').prependTo('header');

  if ($('body').hasClass('fair-landing-page')) {
    $('.navDummyLink:contains("Fair")').closest('.group').addClass('fairMenu');
    const hooplandiaHeaderMenu = `
      <div class="inner-container">
        <div class="fair-logo"></div>
        <div class="fair-mob-nav-toggle"></div>
        <div class="header-top-right">
          <div class="header-right">
            <div class="fair-email"></div>
            <div class="fair-search"></div>
            <div class="fair-ticket"></div>
          </div>
          <div class="fair-nav"></div>
        </div>
      </div>
    `;

    $('#headerFairSubpage').append(hooplandiaHeaderMenu);
    $('.header .header-top-right .searchBox').appendTo(
      '#headerFairSubpage .header-right .fair-search',
    );
    $('.header .header-top-right .emailSignup.modalOnly').appendTo('.fair-email');
    $('.header .ticket').appendTo('.fair-ticket');
    $('.header-top-right .mobile-nav-toggle').appendTo('.fair-mob-nav-toggle');
    $('.fairSub a.subpageheader-logo').appendTo('.fair-logo');
    $('.header-top-right #mainNavigation').appendTo('.fair-nav');
  } else {
    $('#headerFairSubpage').remove();
    $('.header .emailSignup.modalOnly').remove();
    $('.header .ticket').remove();
    $('a.subpageheader-logo').remove();
  }
  // if (window.location.href.includes('/events')) {
  //   document.body.classList.add('subpagetheme', 'fair-landing-page');
  // }
  // HOOPLANDIA HOMEPAGE STRUCTURE
  if ($('body').hasClass('fair-landing-page')) {
    $('.content').append(`  
      <div class="fair-container">
        <div class="tier-one"></div>
        <div class="tier-two">
          <div class="tier-three-container"></div>
        </div>
        <div class="tier-three"></div>
        <div class="tier-four">
          <div class="mapContainer"></div>
        </div>
        <div class="tier-five"></div>
      </div>
    `);

    $(`#mainFeatureSlideShow`).appendTo('.tier-one');

    const hooplandiaFooter = `     
      <div class="sponsor-outer"></div>
      <div class="footer-fair-logo"></div>
      <div class="footer-fairinfo"></div>
      <div class="footeritem"></div>
    `;

    $('.fair-footer').append(hooplandiaFooter);
    $(`#sponsorWidgetContainer`).appendTo('.sponsor-outer');
    $(`#fairSponsors`).appendTo('.sponsor-outer');
  } else {
    $('.fair-footer').remove();
    $(`#sponsorWidgetContainer`).remove();
    $(`#fairSponsors, .footer-top, .bottom-footer`).remove();
  }
  $('#countdown-timer').appendTo('.tier-three-container');
  $('#siteInfoBannerWidget').appendTo('.tier-three-container');
  $(`#multiScheduleFeature`).appendTo('.mapContainer');
  $(`#managedeventfeed`).appendTo('.mapContainer');
  $(`#cardMap`).appendTo('.mapContainer');

  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);
});

$(window).on('load', function () {
  $('body').addClass('pageIsLoaded');
});
